import landingSoftwareInnovationNetworkIcon from "./images/landing-software-innovation-Network-Icon.png";
import landingSoftwareInnovationLayer1 from "./images/landing-software-innovation-layer-1.png";
import landingSoftwareInnovationConnectIcon from "./images/landing-software-innovation-Connect-Icon.png";
import landingSoftwareInnovationProtectIcon from "./images/landing-software-innovation-Protect-Icon.png";
import landingSoftwareInnovationTalkIcon from "./images/landing-software-innovation-Talk-Icon.png";
import landingSoftwareInnovationLayer3 from "./images/landing-software-innovation-layer-3.png";
import landingSoftwareInnovationAccessIcon from "./images/landing-software-innovation-Access-Icon.png";

export default {
  v: "5.12.1",
  fr: 30,
  ip: 0,
  op: 140,
  w: 1460,
  h: 720,
  nm: "Brand-Slide-4-Size",
  ddd: 0,
  assets: [
    {
      id: "image_0",
      w: 712,
      h: 712,
      u: "",
      p: landingSoftwareInnovationNetworkIcon,
      e: 0,
    },
    {
      id: "image_1",
      w: 766,
      h: 1076,
      u: "",
      p: landingSoftwareInnovationLayer1,
      e: 0,
    },
    {
      id: "image_2",
      w: 422,
      h: 422,
      u: "",
      p: landingSoftwareInnovationConnectIcon,
      e: 0,
    },
    {
      id: "image_3",
      w: 836,
      h: 836,
      u: "",
      p: landingSoftwareInnovationProtectIcon,
      e: 0,
    },
    {
      id: "image_4",
      w: 584,
      h: 584,
      u: "",
      p: landingSoftwareInnovationTalkIcon,
      e: 0,
    },
    {
      id: "image_5",
      w: 1318,
      h: 880,
      u: "",
      p: landingSoftwareInnovationLayer3,
      e: 0,
    },
    {
      id: "image_6",
      w: 668,
      h: 668,
      u: "",
      p: landingSoftwareInnovationAccessIcon,
      e: 0,
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 2,
      ty: 3,
      nm: "pos-2",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [725, 355, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 3,
      nm: "pos-4",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [724, 365, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 3,
      nm: "pos-access",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [745, 377, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 3,
      nm: "pos-network",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [755, 347, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 3,
      nm: "pos-talk",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [717, 345, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 3,
      nm: "pos-protect",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [737, 365, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 3,
      nm: "pos-connect",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [725, 375, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 2,
      nm: "Network-Icon.png",
      cl: "png",
      parent: 5,
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [-90, 110, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [-100, 190, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [356, 356, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [35, 35, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 2,
      nm: "layer-1.png",
      cl: "png",
      parent: 2,
      refId: "image_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 0,
              s: [20],
            },
            { t: 20, s: [0] },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [628.063, 94.063, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [564.063, 94.063, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [383, 538, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [35, 35, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 2,
      nm: "Connect-Icon.png",
      cl: "png",
      parent: 8,
      refId: "image_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [186, -85, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [126, -155, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [211, 211, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [30, 30, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 2,
      nm: "Protect-Icon.png",
      cl: "png",
      parent: 7,
      refId: "image_3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [473, -95, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [393, -185, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [418, 418, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [30, 30, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 13,
      ty: 2,
      nm: "Talk-Icon.png",
      cl: "png",
      parent: 6,
      refId: "image_4",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [449, 167, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [419, 217, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [292, 292, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [25, 25, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 14,
      ty: 2,
      nm: "layer-3.png",
      cl: "png",
      refId: "image_5",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [967, 407, 0], ix: 2, l: 2 },
        a: { a: 0, k: [659, 440, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [30, 30, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 15,
      ty: 2,
      nm: "Access-Icon.png",
      cl: "png",
      parent: 4,
      refId: "image_6",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [45, -76, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [-95, -206, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [334, 334, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [30, 30, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
  ],
  markers: [
    { tm: 20, cm: "1", dr: 0 },
    { tm: 140, cm: "2", dr: 0 },
  ],
  props: {},
};
